import { render } from "./BulkUploadContainer.vue?vue&type=template&id=063239fa"
import script from "./BulkUploadContainer.vue?vue&type=script&lang=js"
export * from "./BulkUploadContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__